<script lang="ts">
  interface Props {
    title: string;
    url: string;
    class?: string;
  }

  let { title, url, class: className = '' }: Props = $props();

  let copied = $state(false);

  function copyLink() {
    navigator.clipboard.writeText(url);
    copied = true;
    setTimeout(() => (copied = false), 2000);
  }

  let encodedTitle = $derived(encodeURIComponent(title));
  let encodedUrl = $derived(encodeURIComponent(url));

  let shareLinks = $derived({
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
  });
</script>

<div class="flex items-center gap-3 {className}">
  <span class="text-[10px] font-bold text-dim-30 uppercase tracking-widest mr-1">Share</span>
  
  <a 
    href={shareLinks.linkedin} 
    target="_blank" 
    rel="noopener noreferrer"
    class="w-9 h-9 rounded-full border border-dim-8 bg-card flex items-center justify-center text-dim-50 hover:text-[#C9A87C] hover:border-[#C9A87C]/30 transition-all"
    aria-label="Share on LinkedIn"
  >
    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
    </svg>
  </a>

  <button 
    onclick={copyLink}
    class="w-9 h-9 rounded-full border border-dim-8 bg-card flex items-center justify-center text-dim-50 hover:text-[#C9A87C] hover:border-[#C9A87C]/30 transition-all relative"
    aria-label="Copy link"
  >
    {#if copied}
      <div class="absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 rounded bg-[#7A9E90] text-white text-[10px] font-bold whitespace-nowrap animate-fade-up">
        Copied!
      </div>
      <svg class="w-4 h-4 text-[#7A9E90]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    {:else}
      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
      </svg>
    {/if}
  </button>
</div>
